export class File {
    id?: string;
    name?: string;
    file?: string;
}
